export default __webpack_public_path__ + "static/media/Off.85a9c383.svg";